import "./3DSecureIframeStyle.css"
import React, { useState } from "react"
import ClipLoader from "react-spinners/ClipLoader"
import ReactSrcDocIframe from "react-srcdoc-iframe"

export default ({ axeptaResponse }) => {
  const [isLoading, setIsLoading] = useState(true)

  const handleLoad = () => {
    setIsLoading(false)
  }

  return (
    <div className="popup">
      <div className="popup_inner">
        {isLoading && <ClipLoader size={100} />}
        {axeptaResponse.axeptaCardType === "V1_3DS" ? (
          <ReactSrcDocIframe
            srcDoc={axeptaResponse.axeptaIframContent}
            onLoad={handleLoad}
            width="100%"
            height="100%"
          />
        ) : (
          <iframe
            src={axeptaResponse.axeptaIframContent.replace('"', "").replace('"', "")}
            onLoad={handleLoad}
            width="100%"
            height="100%"
            display="initial"
            position="relative"
            title="3DSecure"
          />
        )}
      </div>
    </div>
  )
}
